import React from "react";

import { IgButton, IgChip, IgTypography, SxProp } from "@intelligems/ig-theme";
import { ExpressionPayloadType } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { SxProps } from "@mui/system";

import { formatQueries } from "../utils";

interface ExpressionOverviewProps {
  expressionsList: ExpressionPayloadType[];
  onResetClick: () => void;
  drawer: boolean;
  hideText?: boolean;
  chipSx?: SxProps;
}

export const ExpressionOverview = ({
  expressionsList,
  onResetClick,
  drawer,
  hideText,
  chipSx,
}: ExpressionOverviewProps) => {
  if (expressionsList.length === 0) {
    return (
      <Grid
        item
        container
        alignItems={"center"}
        xs={1}
        sx={{ minHeight: "40px" }}
      >
        <Grid item>
          <IgChip sx={{ ...chipSx }} key={"all"} label={"All Visitors"} />
        </Grid>
      </Grid>
    );
  } else
    return (
      <Grid
        item
        container
        direction={"row"}
        alignItems={"center"}
        columnSpacing={2}
        wrap={"nowrap"}
      >
        {!hideText && (
          <Grid item>
            <IgTypography sx={{ fontSize: "14px", fontWeight: 400 }}>
              Visitors matching all of:
            </IgTypography>
          </Grid>
        )}

        <Grid item>
          <Grid
            item
            container
            direction={"row"}
            columnSpacing={1}
            rowSpacing={1}
            alignItems={"center"}
          >
            {expressionsList.map((expression) => {
              return (
                <Grid item key={expression.type}>
                  <IgChip
                    sx={{ ...chipSx }}
                    key={expression.type}
                    label={`${formatQueries(expression.queries)}`}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Grid>
        {!drawer && (
          <Grid item>
            <IgButton onClick={onResetClick}>Reset</IgButton>
          </Grid>
        )}
      </Grid>
    );
};
